<template lang="pug">

    div

        .ui.top.attached.header Allgemeine Informationen:
        .ui.bottom.attached.segment
            address-general-information-form(
                ref="generalInformationForm"
                v-bind:company-models='companyModels'
                v-bind:country-models='countryModels'
                v-model='model'
            )

        .ui.top.attached.header Zusätzliche Angaben:
        .ui.bottom.attached.segment
            address-additional-information-form(v-model='model' ref="additionalInformationForm")

        .ui.top.attached.header Adresstyp:
        .ui.bottom.attached.segment
            address-types-form(
                v-on:default-billing-address="updateDefaultBillingAddress"
                v-on:default-correspondence-address="updateDefaultCorrespondenceAddress"
                v-on:default-shipping-address="updateDefaultShippingAddress"
                v-bind:is-default-billing-address='defaultBillingAddress'
                v-bind:is-default-correspondence-address='defaultCorrespondenceAddress'
                v-bind:is-default-shipping-address='defaultShippingAddress'
                v-model='model' ref="typeForm"
            )

        .ui.top.attached.header Avis:
        .ui.bottom.attached.segment
            address-advice-form(v-model='model.advice' ref="adviceForm")

        //- Actions
        action-row.ui.bottom.secondary(v-on:cancel="cancel")

</template>

<script>
    import * as R from 'ramda'
    import size from 'lodash/fp/size'
    import { create_default_addresses_patch } from '@/utils/company'
    import ActionRow from '@/components/form/ActionRow'
    import AddressAdditionalInformationForm from '@/components/addresses/form/AdditionalInformation'
    import AddressAdviceForm from '@/components/addresses/form/Advice'
    import AddressGeneralInformationForm from '@/components/addresses/form/GeneralInformation'
    import AddressTypesForm from '@/components/addresses/form/Types'
    import Navigation from '@/components/addresses/Navigation'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols,ReservedWordAsName
    export default {

        components: {
            ActionRow, AddressAdditionalInformationForm, AddressAdviceForm,
            AddressGeneralInformationForm, AddressTypesForm, Navigation
        },

        computed: {

            companyModel() {
                const link = R.head(this.model.companies || [])
                const companyId = link ? link.company : undefined
                return R.defaultTo({}, R.find(R.propEq('id', companyId), this.companyModels))
            },

        },

        data() {
            return {
                defaultBillingAddress: false,
                defaultCorrespondenceAddress: false,
                defaultShippingAddress: false,
                model: {
                    advice: '',
                    companies: [],
                    country: 34,
                }
            }
        },

        methods: {

            persist() {
                // Adresse speichern
                return this.$store.dispatch('addresses/create', { model: this.model }).then(addressModel => {

                    // Adresse ggf. als Default-Adresse speichern
                    return this.persistDefaultAddress(addressModel.id).then(R.always(addressModel))

                })
            },

            persistDefaultAddress(id) {
                const model = create_default_addresses_patch(this.companyModel.id, id)(this.$data)

                if (size(model) > 1) {
                    return this.$store.dispatch('companies/patch', { model })
                } else {
                    return Promise.resolve()
                }
            },

            updateDefaultBillingAddress(value) {
                this.defaultBillingAddress = value
            },

            updateDefaultCorrespondenceAddress(value) {
                this.defaultCorrespondenceAddress = value
            },

            cancel() {
                this.$emit('cancel')
            },

            updateDefaultShippingAddress(value) {
                this.defaultShippingAddress= value
            },

            async validate() {
                const result = await Promise.all([
                    this.$validate(),
                    this.$refs.additionalInformationForm.validate(),
                    this.$refs.adviceForm.validate(),
                    this.$refs.generalInformationForm.validate(),
                    this.$refs.typeForm.validate()
                ])

                return R.all(R.equals(true), result)
            }

        },

        props: {

            companyModels: {
                type: Array,
                required: true
            },

            countryModels: {
                type: Array,
                required: true
            }

        },

        validators: {},

        watch: {
        }

    }

</script>
